import { actionsQueryTypePolicies } from "./actions"
import { integrationQueryTypePolicies } from "./integrations"
import { processTypePolicies, jobProcessStepTypePolicies } from "./jobs"
import { notificationPostTypePolicies } from "./notifications"
import { postsQueryTypePolicies, postTypePolicies } from "./posts"
import { sensorTypePolicies } from "./sensors"
import { trainingCourseTypePolicies } from "./training"
import { adminableUsersQueryTypePolicies, userAccreditationTypePolicies } from "./users"

const typePolicies = {
  Query: {
    fields: {
      ...postsQueryTypePolicies,
      ...actionsQueryTypePolicies,
      ...adminableUsersQueryTypePolicies,
    },
  },
  ...integrationQueryTypePolicies,
  ...jobProcessStepTypePolicies,
  ...postTypePolicies,
  ...processTypePolicies,
  ...notificationPostTypePolicies,
  ...sensorTypePolicies,
  ...trainingCourseTypePolicies,
  ...userAccreditationTypePolicies,
}

export { typePolicies }
